import { Link } from "gatsby";
import React from "react";
import { __t } from "../../utils/translate";

type NavigationProps = {
    className?: string;
    currentPage: string;
    collection?: string;
    collectionSlug?: string;
    prefixSlug?: string;
    onNavigate?: () => void;
};

const Navigation: React.FC<NavigationProps> = ({
    className = "",
    collection,
    currentPage,
    collectionSlug,
    prefixSlug = '',
    onNavigate,
}) => {
    return (
        <div
            className={`${className} text-small-14 !tracking-[-0.21px] text-[#444] py-[32px] sm:py-[20px]`}
        >
            <Link to="/">
                <span className="hover:text-button-accent-color">{__t("Home")}</span><span className="text-gray/40 mx-2">/</span>
            </Link>
            {!!collection && (
                <Link to={`${prefixSlug}${collectionSlug}`} onClick={onNavigate}>
                    <span className="hover:text-button-accent-color" dangerouslySetInnerHTML={{ __html: collection }} /><span className="text-gray/40 mx-2">/</span>
                </Link>
            )}
            <span className="text-gray" dangerouslySetInnerHTML={{ __html: currentPage }} />
        </div>
    );
};

export default Navigation;
